<div class="one-column-page">
  <div class="one-column-content">
    <h1>{{'SCENARIO_COMPARISON.RESULTS.HEADER' | anessaTranslation: trigger}}</h1>

    <!-- Scenario Select -->
    <div class="flex-container" style="padding-top:15px">
      <div class="flex-box width_100">
        <mat-form-field floatLabel="never" class="custom-angular-dropdown scenario-comparison-dropdown anessa-dropdown">
          <mat-select
            id="scenario-results-scenario_select"
            multiple
            [placeholder]="'SCENARIO_COMPARISON.RESULTS.SCENARIO_SELECT_PLACEHOLDER' | anessaTranslation: trigger"
            [(value)]="selectedScenarios"
            disableOptionCentering
            (valueChange)="processData()"
            panelClass="anessa-dropdown-panel">
            <ng-container *ngFor="let sce of scenarios">
              <mat-option
                *ngIf="sce.results"
                [disabled]="selectedScenarios.length >= 10 && !selectedScenarios.includes(sce.name)"
                [value]="sce.name">{{ sce.name }}
              </mat-option>
            </ng-container>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <!--START SELECTION BOXES-->
    <!-- Result Category Select -->
    <div class="flex-container flex-align-item-center">
      <i class="material-icons search-margin"
        (click)="onSearchClick()"
      >search</i>
      <div class="flex-box width_33">
        <mat-form-field floatLabel="never" class="custom-angular-dropdown scenario-comparison-dropdown anessa-dropdown">
          <mat-select
            id="scenario-results-category_select"
            [(value)]="selectedCategory"
            [disabled]="!dataReady"
            [placeholder]="'RESULTS.GENERAL.SET_CATEGORY' | anessaTranslation: trigger"
            disableOptionCentering
            (valueChange)="selectedCategoryChanged()"
            panelClass="anessa-dropdown-panel">
            <mat-option
              *ngFor="let category of resultCategories"
              [disabled]="financialDisabled(category)"
              [value]="category">{{ category | anessaTranslation: trigger}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <!-- Result Group Select -->
      <div class="flex-box width_33" *ngIf="selectedCategory !== 'RESULTS.SECTIONS.FEEDSTOCK_BREAKDOWN'">
        <mat-form-field floatLabel="never" class="custom-angular-dropdown scenario-comparison-dropdown anessa-dropdown">
          <mat-select
            id="scenario-results-group_select"
            [(value)]="selectedResultGroup"
            [disabled]="!selectedCategory"
            [placeholder]="'SCENARIO_COMPARISON.RESULTS.SELECT_GROUP' | anessaTranslation : trigger"
            disableOptionCentering
            (valueChange)="selectedGroupChanged()"
            panelClass="anessa-dropdown-panel">
            <mat-option
              *ngFor="let group of resultGroups"
              [value]="group">{{
              isPossibleTranslationId(group.name) ? (group.name | anessaTranslation: trigger: group.params) : group.name
              }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <!-- Result Item Select -->
      <div class="flex-box width_33">
        <mat-form-field floatLabel="never" class="custom-angular-dropdown scenario-comparison-dropdown anessa-dropdown">
          <mat-select
            id="scenario-results-item_select"
            multiple
            [(value)]="selectedResultItems"
            [disabled]="!selectedCategory"
            [placeholder]="'SCENARIO_COMPARISON.RESULTS.SELECT_ITEMS' | anessaTranslation: trigger"
            disableOptionCentering
            (valueChange)="selectedItemsChanged()"
            panelClass="anessa-dropdown-panel">
            <mat-option
              *ngFor="let item of resultItems"
              [value]="item">
              <p [innerHTML]="isPossibleTranslationId(item.name) ? (item.name | anessaTranslation: trigger: item.params) : item.name"></p>
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <!-- Period Select -->
    <div class="flex-container">
      <div class="flex-box" *ngIf="isShowFrequencyDropdown()">
        <mat-form-field floatLabel="never" class="custom-angular-dropdown scenario-comparison-dropdown anessa-dropdown">
          <mat-select
            id="scenario-results-period_select"
            [(value)]="selectedPeriod"
            [placeholder]="'RESULTS.GENERAL.SET_PERIOD' | anessaTranslation: trigger"
            disableOptionCentering
            (valueChange)="processData()"
            panelClass="anessa-dropdown-panel">
            <mat-option
              *ngFor="let period of periodCategories"
              [value]="period.value">{{ period.translationId | anessaTranslation: trigger }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <!-- Currency Select -->
      <div class="flex-box" *ngIf="isShowCurrencyDropdown()">
        <mat-form-field floatLabel="never" class="custom-angular-dropdown scenario-comparison-dropdown anessa-dropdown">
          <mat-select
            id="scenario-results-currency_select"
            [(value)]="selectedCurrency"
            [placeholder]="'RESULTS.GENERAL.SET_CURRENCY' | anessaTranslation: trigger"
            disableOptionCentering
            [disabled]="!finCurrencyReady"
            (valueChange)="processData()"
            panelClass="anessa-dropdown-panel">
            <mat-optgroup [label]="exchangeRateDate">
              <mat-option
                *ngFor="let currency of financialExchange"
                [value]="currency">{{ currency.translationId | anessaTranslation: trigger }}</mat-option>
            </mat-optgroup>
          </mat-select>
        </mat-form-field>
      </div>

      <!-- Unit Select -->
      <div class="flex-box" *ngIf="isShowUnitDropdown()">
        <mat-form-field floatLabel="never" class="custom-angular-dropdown scenario-comparison-dropdown anessa-dropdown">
          <mat-select
            id="scenario-results-unit_select"
            [(value)]="techUnitType"
            [placeholder]="'RESULTS.GENERAL.SET_UNIT_TYPE' | anessaTranslation: trigger"
            disableOptionCentering
            (valueChange)="processData()"
            panelClass="anessa-dropdown-panel">
              <mat-option
                *ngFor="let opt of techUnitTypes"
                [value]="opt.value">{{ opt.translationId | anessaTranslation: trigger}}
              </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <!--END SELECTION BOXES-->

    <div class="fl" *ngIf="isShowResults()">
      <p>{{'RESULTS.GENERAL.EXCHANGE_RATES_FROM' | anessaTranslation: trigger}} <i>{{ exchangeRateDate }}</i></p>
    </div>

    <!--Result display from here on-->
    <div class="row fl" *ngIf="isShowResults()">
      <div class="fl-item" *ngIf="this.showTreeTable">
        <results-treetable
          [idPrefix]="'scenario-results-table'"
          [valueKey]="valueKey"
          [customColumnOrder]="curTableHeaders"
          [resultsData]="treeTableData"
          [groupAggregationMethod]="aggMethod"
          [aggregationWhiteList]="aggWhitelist"
          [firstColumnHeader]="customFirstColumnHeader | anessaTranslation: trigger"
        ></results-treetable>
      </div>
    </div>

    <div class="row fl" *ngIf="isShowResults()">
      <div class="fl-item" *ngIf="showGroupBarGraph">
        <app-graph-selector
          [idPrefix]="'scenario-results-barGraph'"
          [graphData]="curGraphData"
          [graphType]="'raw'"
          [yAxisLabel]="yAxisLabel"
          [xAxisLabel]="xAxisLabel"
        ></app-graph-selector>
      </div>

      <div class="fl-item" *ngIf="showPieChart">
        <app-graph-selector
          [idPrefix]="'scenario-results-pieGraph'"
          [graphType]="'raw'"
          [customLayout]="graphLayout"
          [graphData]="curGraphData"
          [precision]="precision"
        ></app-graph-selector>
      </div>
    </div>
  </div>
</div>
